module.exports = __webpack_public_path__ + "sunsemweb/img/sss.fab7c9ce.png";